import BankDetailsContainer from './BankDetailsContainer';

export {
    BankDetailsContainer
};

export default BankDetailsContainer;
